import { FC } from 'react';
import { CatTooltip } from '@blocks-react/components/Tooltip';
import { CatIconHide } from '@blocks-react/components/Icons/Hide';
import { CatTextPassage } from '@blocks-react/components/TextPassage';
import { CatIconCloseCircle } from '@blocks-react/components/Icons/CloseCircle';
import { DismissedNotificationsProps } from '../types';
import styles from '../NotificationDrawer.module.scss';

export const DismissedNotifications: FC<DismissedNotificationsProps> = ({
  isDismissed,
  handleClose,
  dismissedHoverLabel,
  handleDismiss,
  dismissHoverLabel,
  dynamicClassName = ''
}) => {
  return (
    <CatTooltip
      position="top"
      data-testid="dismissed-tootip"
      className={`${styles['dismiss-tool-tip']} ${
        !isDismissed ? dynamicClassName : ''
      }`}
      onBlTooltipClose={handleClose}
    >
      {isDismissed ? (
        <>
          <CatIconHide
            slot="trigger"
            tabIndex={0}
            aria-label={dismissedHoverLabel}
          />
          <CatTextPassage size="xs">{dismissedHoverLabel}</CatTextPassage>
        </>
      ) : (
        <>
          <button
            slot="trigger"
            onClick={handleDismiss}
            tabIndex={0}
            className="border-0 bg-transparent"
          >
            <CatIconCloseCircle aria-label={dismissHoverLabel} />
          </button>
          <CatTextPassage size="xs">{dismissHoverLabel}</CatTextPassage>
        </>
      )}
    </CatTooltip>
  );
};
